export const handleAuthError = (error: any) => {
  // Check if this is a partial 2FA validation success (401 with pendingMethods)
  // In this case, don't throw - let the caller handle it
  if (error.response?.status === 401 && error.response?.data?.pendingMethods) {
    throw error;
  }

  const status = error.response?.status;

  // New API format: { status: 4xx, errors: { field: "message" } }
  const errorsObj = error.response?.data?.errors;
  let errorMessage: string;

  if (errorsObj && typeof errorsObj === 'object') {
    const firstValue = Object.values(errorsObj)[0];
    errorMessage = typeof firstValue === 'string' ? firstValue : 'An error occurred during the process.';
  } else {
    errorMessage =
      error.response?.data?.error ||
      error.response?.data?.message ||
      'An error occurred during the process.';
  }

  const customError = new Error(errorMessage);
  (customError as any).status = status;
  throw customError;
};
